<template>
  <b-form-group>
    <b-form-checkbox
      v-model="dataItem.is_public"
      :value="1"
      :unchecked-value="0"
      :disabled="disabled"
    >
      {{ $t('tasks.form.visibility') }}
    </b-form-checkbox>
    <b-form-text class="mt-25">
      {{ hintText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormCheckbox, BFormText } from 'bootstrap-vue'

export default {
  name: 'TasksVisibilityCard',
  components: { BFormGroup, BFormCheckbox, BFormText },
  props: {
    storeModule: {
      type: String,
      default: 'tasks',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
  },
  computed: {
    hintText() {
      return this.hint ?? this.$t('tasks.form.visibilityHint')
    },
    dataItem() {
      return this.$store.getters[`${this.storeModule}/dataItem`]
    },
  },
}
</script>
